import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LANGS } from "./homeI18n";
import { H } from "../components/home/homeV2I18n";
import { Ferry, FaqHelp, BottomBar } from "../components/home/HomeSections";
import api from "../lib/api";
import { MagazineTeaser } from "../components/magazine/MagazineTeaser";
import { setHead, ORG } from "../lib/seoHead";
import { pickLang, saveLang, switchLang } from "../lib/langs";
import { MHeader, MHero, MIntro, MExperiences, MCollection, MFooter } from "../components/home/Maison";

const afterLoad = (fn) => {
  const run = () => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 300));
  if (document.readyState === "complete") { run(); } else { window.addEventListener("load", run, { once: true }); }
};

export default function Home() {
  const [lang, setLang] = useState(() => pickLang("en"));
  const [q, setQ] = useSearchParams();
  // Keep ?lang= in the URL (path and other params preserved) so reload and back/forward keep the language.
  const changeLang = (l) => { setLang(l); const n = new URLSearchParams(window.location.search); n.set("lang", l); setQ(n); };
  const urlLang = q.get("lang");
  useEffect(() => { if (urlLang && LANGS.includes(urlLang) && urlLang !== lang) { switchLang(urlLang, setLang); } }, [urlLang]); // eslint-disable-line react-hooks/exhaustive-deps
  const [wa, setWa] = useState(null);
  useEffect(() => { afterLoad(() => api.get("/public/site-contact").then((r) => setWa(r.data.whatsapp || null)).catch(() => {})); const t = setTimeout(() => document.getElementById("av-boot")?.remove(), 6000); return () => { clearTimeout(t); document.getElementById("av-boot")?.remove(); }; }, []);
  useEffect(() => {
    saveLang(lang);
    setHead({ title: `AMALFI VIBES — ${H.hero[lang]}`, path: "/", lang, image: "/experiences/coast1.webp",
      description: "AMALFI VIBES: Vespa and scooter rental, private and small-group boat tours, car rental, private transfers, ferries, photo shoots and the official AMALFI VIBES shop on the Amalfi Coast.",
      jsonld: { "@context": "https://schema.org", "@graph": [ORG, { "@type": "WebSite", name: "AMALFI VIBES", url: "https://amalfivibes.com/" }] } });
  }, [lang]);
  return (
    <main className="pp-root maison bg-[#F7F5F0] text-[#242321] overflow-x-clip [&_a:focus-visible]:outline-2 [&_a:focus-visible]:outline-[#242321] [&_a:focus-visible]:outline-offset-2 [&_button:focus-visible]:outline-2 [&_button:focus-visible]:outline-[#242321] [&_button:focus-visible]:outline-offset-2" data-testid="home-page">
      <MHeader lang={lang} setLang={changeLang} />
      <MHero lang={lang} />
      <MIntro lang={lang} />
      <MExperiences lang={lang} />
      <Ferry lang={lang} />
      <MCollection lang={lang} />
      <MagazineTeaser lang={lang} />
      <FaqHelp lang={lang} wa={wa} />
      <MFooter lang={lang} />
      <BottomBar lang={lang} />
    </main>
  );
}
